import React, { useEffect,useState} from "react";
import { Box } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./Sectors.scss";
import HeaderSectors from "./HeaderSectors";
import { getSectorById } from "../../actions/sector/sectorActions";

const SectorsInnerLayout = ({ currentTab, changeTab }) => {
  const { sectorId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (sectorId) {
      dispatch(getSectorById(sectorId));
    }
  }, [dispatch, sectorId]);

  const [selectedSectorData, setSelectedSectorData] = useState(null);

// When sector icon is clicked
const handleSectorClick = (sectorId) => {
  setSelectedSectorData(sectorId);
};
  console.log("====currentTab", currentTab);
  return (
    <Box w="100%" bg="var(--body-bg)">
      <Box>
        <HeaderSectors currentTab={currentTab} changeTab={changeTab}     />
      </Box>
    </Box>
  );
};

export default SectorsInnerLayout;
